import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=795833e4&scoped=true&"
import script from "./Tracking.vue?vue&type=script&lang=js&"
export * from "./Tracking.vue?vue&type=script&lang=js&"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=795833e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795833e4",
  null
  
)

export default component.exports